module.exports = __webpack_public_path__ + "img/ordTNiac4.2a9ab3d1.jpg";